import type { PropsWithChildren } from 'react';

import { FontFace, Reset } from '@opendoor/bricks/styles';
import { Themed } from '@opendoor/bricks/theme/ODTheme';

export const ThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Themed theme="novo">
      <FontFace />
      <Reset />
      {children}
    </Themed>
  );
};
